import RaterPriceClientProduct from '@/modules/common/common/models/MID/RaterPriceClientProduct'
import HealthRaterPriceInsuredToSave from '@/modules/health/common/models/MID/HealthRaterPriceInsuredToSave'

export default class HealthRaterPriceRequest {
  /** (String): Identificador de la solicitud. Ejemplo: "63a075f1-f89b-4b86-8967-444baa63d30f". Obligatorio para una retarificación. */
  quotationId: string | undefined

  /** (Integer): Número de cotización. Ejemplo: "4798669". Obligatorio para una retarificación. */
  quotationNumber!: string | undefined

  /** (String): Línea de negocio. Ejemplo: "AS00". Obligatorio para una primera tarificación. */
  businessLine!: string

  /** (DateTime): Fecha de inicio de seguro. Ejemplo: "2024-05-24". Obligatorio para una primera tarificación. */
  insuranceStartDate!: string

  /** (String): Tipo de seguro. Ejemplo: "1". Obligatorio para una primera tarificación. */
  insuranceType: string

  /** (String): Código postal del titular de la póliza. Ejemplo: "28041". Obligatorio para una primera tarificación. */
  policyHolderPostal!: string

  /** (Array): Listado de asegurados. */
  insureds!: HealthRaterPriceInsuredToSave[]

  /** (Array, opcional): Listado de productos del cliente. */
  clientProduct?: RaterPriceClientProduct[] | null

  stayAbroadType?: string | null

  /** Si debe dejar registro en Senda o no */
  isQuote: boolean = false

  /** (String, opcional): Código del mediador. */
  mediator?: string

  constructor(data: HealthRaterPriceRequest) {
    if (data.quotationId) this.quotationId = data.quotationId // must not send if its null or undefined
    this.quotationNumber = data.quotationNumber
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.insuranceType = data.insuranceType
    this.policyHolderPostal = data.policyHolderPostal
    this.insureds = data.insureds?.map((i) => new HealthRaterPriceInsuredToSave(i))
    this.clientProduct = data.clientProduct?.map((cp) => new RaterPriceClientProduct(cp))
    this.stayAbroadType = data.stayAbroadType ?? null
    this.isQuote = data.isQuote
    if (data.mediator) this.mediator = data.mediator
  }
}
